export class Confirmation {
  public constructor(
    public readonly title: string,
    public readonly message: string,
    public readonly acceptLabel: string,
    public readonly rejectLabel: string,
    public readonly accept: () => void,
    public readonly reject: () => void,
  ) {}
}
